<button
  lyceoButton
  [fill]="buttonFill"
  [size]="buttonSize"
  (click)="openFeedbackModal()"
>
  {{ buttonText() }}
</button>
